/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReturnToFacilityRequest
 */
export interface ReturnToFacilityRequest {
    /**
     * 
     */
    move_in_date: string;
    /**
     * 
     */
    scheduled_move_out_date?: string;
    /**
     * 
     */
    bed_id?: string;
    /**
     * 
     */
    stay_type: ReturnToFacilityRequestStayTypeEnum;
    /**
     * 
     */
    comment?: string;
}


/**
 * @export
 */
export const ReturnToFacilityRequestStayTypeEnum = {
    LongTerm: 'Long-Term',
    ShortTerm: 'Short-Term',
} as const;
export type ReturnToFacilityRequestStayTypeEnum = typeof ReturnToFacilityRequestStayTypeEnum[keyof typeof ReturnToFacilityRequestStayTypeEnum];


/**
 * Check if a given object implements the ReturnToFacilityRequest interface.
 */
export function instanceOfReturnToFacilityRequest(value: object): value is ReturnToFacilityRequest {
    if (!('move_in_date' in value) || value['move_in_date'] === undefined) return false;
    if (!('stay_type' in value) || value['stay_type'] === undefined) return false;
    return true;
}

export function ReturnToFacilityRequestFromJSON(json: any): ReturnToFacilityRequest {
    return ReturnToFacilityRequestFromJSONTyped(json, false);
}

export function ReturnToFacilityRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReturnToFacilityRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'move_in_date': json['move_in_date'],
        'scheduled_move_out_date': json['scheduled_move_out_date'] == null ? undefined : json['scheduled_move_out_date'],
        'bed_id': json['bed_id'] == null ? undefined : json['bed_id'],
        'stay_type': json['stay_type'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function ReturnToFacilityRequestToJSON(json: any): ReturnToFacilityRequest {
    return ReturnToFacilityRequestToJSONTyped(json, false);
}

export function ReturnToFacilityRequestToJSONTyped(value?: ReturnToFacilityRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'move_in_date': value['move_in_date'],
        'scheduled_move_out_date': value['scheduled_move_out_date'],
        'bed_id': value['bed_id'],
        'stay_type': value['stay_type'],
        'comment': value['comment'],
    };
}

